export enum PaymentMethodType {
    DNI = 1,            // cédula
    CLOSE_LOOP_CARD = 2,           // tarjeta
    CARD_BANK = 3,      // tarjeta bancaria
    QR = 4,             // qr
    CARD_OPEN_LOOP = 5  // tarjeta open loop
}